import React from "react";
import Collapsible from "react-collapsible";
import {Box, Columns, Table} from "react-bulma-components";


export default function QuoteSection({quotes}){



    return (
        <Box>
            <Collapsible
                trigger={"Quotes"}
                className={"title"}
                triggerOpenedClassName={"title"}
            >
                <Columns>
                    <Columns.Column>
                        <Table size={"fullwidth"} bordered>
                            <thead>
                                <tr>
                                    <th>Quote ID</th>
                                    <th>Customer 1</th>
                                    <th>Customer 2</th>
                                    <th>Customer 1 Estimated Amount</th>
                                    <th>Customer 2 Estimated Amount</th>
                                    <th>Rental ID</th>
                                </tr>
                            </thead>
                            <tbody>
                            {quotes && quotes.map(quote => (
                                <tr>
                                    <td className={"clickable on-hover-highlight"} onClick={() => window.open(`/editquote/${quote.id}`, "_self")}>{quote.id}</td>
                                    <td>{quote.customer ? quote.customer.display_name : ""}</td>
                                    <td>{quote.customer2 ? quote.customer2.display_name : ""}</td>
                                    <td>{quote.custom_value_1}</td>
                                    <td>{quote.custom_value_2}</td>
                                    <td>{quote.rental}</td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </Columns.Column>
                </Columns>
            </Collapsible>
        </Box>
    )

}